import React from 'react';

import { Input } from 'antd';

import { Icon } from '../../atoms/icons';

type FilterProps = {
  pagination: {
    currentPage: number;
    setCurrentPage: (current: number) => void;
  };
  search: {
    searchTerm: string;
    setSearchTerm: (text: string) => void;
  };
  placeholder?: string;
  onClickFilter?: () => void;
  onClickContextMenu?: () => void;
};

const Filter = ({
  search,
  pagination,
  placeholder,
  onClickFilter,
  onClickContextMenu
}: FilterProps) => {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentInput = e.target.value;

    pagination.setCurrentPage(1);

    search.setSearchTerm(currentInput);
  };

  return (
    <div className={'px-7 flex place-content-between items-center'}>
      <Input
        placeholder={placeholder}
        value={search.searchTerm}
        onChange={handleSearch}
        className={'max-w-[345px]'}
        prefix={<Icon iconName={'iconMagnifyingGlass'} className={'h-5 w-5'} />}
      />
      <div className={'flex gap-5 '}>
        {onClickFilter ? (
          <div onClick={onClickFilter}>
            <Icon
              iconName={'iconFunnelSimple'}
              className={'w-5 h-5 cursor-pointer hover:stroke-gray-400'}
            />
          </div>
        ) : (
          <></>
        )}

        {onClickContextMenu ? (
          <div onClick={onClickContextMenu}>
            <Icon
              iconName={'iconDotsThreeVertical'}
              className={'w-5 h-5 cursor-pointer hover:stroke-gray-400'}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export { Filter };
export type { FilterProps };
